import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Router } from '@angular/router';
import { ZardButtonComponent } from '../../../shared/components/button';
import { ZardCardComponent } from '../../../shared/components/card';

@Component({
  selector: 'app-auth-welcome',
  standalone: true,
  imports: [NgOptimizedImage, ZardButtonComponent, ZardCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './auth-welcome.component.html',
  styleUrl: './auth-welcome.component.css',
})
export class AuthWelcomeComponent {
  protected readonly router = inject(Router);

  protected readonly layoutOuter = 'min-h-screen flex flex-col md:flex-row bg-gray-50 md:bg-white';
  protected readonly sidePanelBgImage = 'https://images.unsplash.com/photo-1759863468440-85130c0dff28?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080';
  protected readonly layoutSidePanel =
    'hidden md:flex md:w-1/2 lg:w-5/12 relative overflow-hidden flex-col justify-between p-12 text-white';
  protected readonly layoutOverlay =
    'absolute inset-0 z-0 bg-gradient-to-t from-[#1A2E47] via-[#1A2E47]/50 to-transparent';
}
